module.exports = __webpack_public_path__ + "img/icecreamIn.f150b3a0.svg";